import { forwardRef, type AnchorHTMLAttributes } from 'react';
import { Link as RouterLink, type LinkProps as RouterLinkProps } from 'react-router-dom';

export interface LinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
  /** リンク先URL */
  href?: string;
  /** react-router-dom用の内部リンク先 */
  to?: string;
  /** 追加のクラス名 */
  className?: string;
  /** 子要素 */
  children: React.ReactNode;
}

/**
 * AIPデザインシステムのリンクコンポーネント
 */
export const Link = forwardRef<HTMLAnchorElement, LinkProps>(
  ({ href, to, className = '', children, ...props }, ref) => {
    const combinedClassName = `aip-link ${className}`.trim();

    // 内部リンク（react-router-dom）の場合
    if (to) {
      return (
        <RouterLink
          ref={ref}
          to={to}
          className={combinedClassName}
          {...(props as Omit<RouterLinkProps, 'to'>)}
        >
          {children}
        </RouterLink>
      );
    }

    // 外部リンクの場合
    return (
      <a ref={ref} href={href} className={combinedClassName} {...props}>
        {children}
      </a>
    );
  }
);

Link.displayName = 'Link';

export default Link;

